<template>
  <div class="exception">
    <div class="img">
      <img :src="config[type].img" alt="config[type].title" />
    </div>
    <div class="content">
      <h1>{{ config[type].title }}</h1>
      <div class="desc">{{ config[type].desc }}</div>
      <div class="action">
        <a-button type="primary" @click="redirect">{{
          config[type].redirectText
        }}</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import Config from './typeConfig';

export default {
  name: 'ExceptionPage',
  props: ['type'],
  data() {
    return {
      config: Config
    };
  },
  methods: {
    redirect() {
      let path = this.config[this.type].redirectPath;
      this.$router.push({
        path
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.exception
  align-items center
  text-align center
  padding-top: 150px;
  padding-left 50px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color #f0f2f5
  .img
    display inline-block
    padding-right 52px
    zoom 1
    img
      height 360px
      max-width 430px
  .content
    display inline-block
    vertical-align middle
    h1
      color #434e59
      font-size 72px
      font-weight 600
      line-height 72px
      margin-bottom 24px
    .desc
      color rgba(0, 0, 0, 0.45)
      font-size 20px
      line-height 28px
      margin-bottom 16px
</style>
